import { render, staticRenderFns } from "./material-upload-result.vue?vue&type=template&id=c3f167c0&scoped=true"
import script from "./material-upload-result.vue?vue&type=script&lang=js"
export * from "./material-upload-result.vue?vue&type=script&lang=js"
import style0 from "./material-upload-result.vue?vue&type=style&index=0&id=c3f167c0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f167c0",
  null
  
)

export default component.exports